import { combineReducers } from 'redux';
import clubs from './mpt/clubs';
import weeks from './mpt/weeks';
import userStats from './mpt/userStats';
import cardsStats from './mpt/cardsStats';

export default combineReducers({
    clubs,
    weeks,
    userStats,
    cardsStats,
});



// WEBPACK FOOTER //
// ./src/reducers/app/mpt.js